module.exports = __webpack_public_path__ + "static/media/use_graph01_jpn.f1f0248e.jpg";